import { Button } from "Components/Button";
import KeyboardHint from "Components/KeyboardHint";
import TextInput from "Components/TextInput";
import TwoColumnInput from "Components/TwoColumnInput";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import InfoContentMotionWrapper from "Components/MotionWrapper/InfoContentMotionWrapper";
const CompanyNameFormContent = ({
  submitCB = () => {},
  companyName = null,
  industry = null,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      companyName: companyName || "",
      industry: industry || "",
    },
  });

  useEffect(() => {
    if (companyName || industry) {
      reset({
        companyName: companyName || "",
        industry: industry || "",
      });
    }
  }, [companyName, industry, reset]);
  return (
    <InfoContentMotionWrapper>
      <form noValidate onSubmit={handleSubmit(submitCB)}>
        <TwoColumnInput>
          <TextInput
            id="company-name"
            type="text"
            errorText={errors?.companyName?.message}
            placeholder="公司名稱"
            {...register("companyName", {
              required: {
                value: true,
                message: "請填寫必填欄位",
              },
            })}
          />
          <TextInput
            id="company-industry"
            type="text"
            errorText={errors?.industry?.message}
            placeholder="產業"
            {...register("industry", {
              required: {
                value: true,
                message: "請填寫必填欄位",
              },
            })}
          />
        </TwoColumnInput>
        {/* <button onSubmit={submitCB}>OK</button> */}
        <div style={{ display: "flex", alignItems: "end", gap: "0.75rem" }}>
          <Button marginTop type="action" submit>
            OK
          </Button>
          <KeyboardHint />
        </div>
      </form>
    </InfoContentMotionWrapper>
  );
};

export default CompanyNameFormContent;
